<template>
  <div class="complete notranslate">
    <div class="mb30">
      <p data-status="paid">{{locale.alert_complete_reservation}}</p>
      <div v-if="sendData && sendData.type" class="sendData">
        <div v-if="sendData.type !== 'FAIL'">{{sendMessage}}</div>
        <div v-else class="colorGrey">{{locale.message_reservation_send_fail}}</div>
      </div>
    </div>
    <div
      v-if="isPublic"
      class="qrInfo">
      <div v-if="sendData && sendData.type && sendData.type !== 'FAIL'" class="mb15">{{locale.or}}</div>
      <div class="message">{{ locale.reservation_complete_qrcode }}</div>
      <div v-if="qrCode === 'fail'" class="noQr"><img src="@/assets/img/img_qr_fail.png" alt=""></div>
      <vue-qrcode
        v-else-if="qrCode"
        :value="qrCode"
        :scale="6" />
    </div>
    <div class="btns">
      <router-link :to="{name: 'myReservation', params: {ln: ln}}" class="btn btnRound">{{locale.reservation_list}}</router-link>
      <router-link :to="{name: 'main', params: {ln: ln}}" class="btn btnRound">{{locale.go_main}}</router-link>
    </div>
  </div>
</template>

<script>
import VueQrcode from 'vue-qrcode'

export default {
  name: 'Complete',
  props: [
    'ln',
    'locale',
    'isPublic',
    'reservationId'
  ],
  components: {
    VueQrcode
  },
  computed: {
    auth () {
      return this.$store.getters['authentication/getAuthInfo']
    },
    isPrivate () {
      const noFrame = (this.auth.frame && this.auth.frame === 'false') || false
      return this.isPublic && noFrame
    },
    sendData () {
      const query = this.$route.query
      return query && query.type
      ? {
          type: query.type
        }
      : null
    },
    sendMessage () {
      const sendData = this.sendData && this.sendData.type
      const type = sendData && sendData.toLowerCase()
      const locale = type === 'fail'
        ? this.locale.message_reservation_send_fail
        : type === 'email'
          ? this.locale.message_reservation_send_email
          : this.locale.message_reservation_send_message
      return type && locale
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.isPublic) {
        const authInfo = this.auth
        const win = window.location
        const reservationId = this.reservationId
        let params = publicToOta(win.search)
        let url = ''
        // 공용디바이스 사용자는 개인링크로 변환 params
        function publicToOta (queryString) {
          const params = {}
          queryString.replace(/[#?&]+([^=&]+)=([^&]*)/gi, function (str, key, value) {
            params[key] = value
          })
          params.frame = false
          return params
        }
        delete params.public
        params.k = authInfo.k
        params = Object.entries(params).map(e => e.join('=')).join('&')
        url = `${win.origin}${win.pathname}?${params}#/${this.ln}/reservation/check/${reservationId}`
        // 공용디바이스 qr코드 생성
        this.$store.dispatch('util/getShortUrl', {
          url: url,
          days: 1
        }).then((res) => {
          if (res) {
            this.qrCode = res
          } else {
            this.qrCode = 'fail'
          }
        })
      }
    })
  },
  data () {
    return {
      qrCode: null
    }
  }
}
</script>

<style lang="scss" scoped>
.complete {
  padding: 80px 30px 200px;
  text-align: center;
  p {
    font-size: 1.5em;
    &:not(.message):before {
      content: "";
      display: block;
      height: 96px;
      margin-bottom: 30px;
      background: url('~@/assets/img/warn.png') 50% 50% / contain no-repeat;
    }
    &[data-status="paid"]:before {
      background-image: url('~@/assets/img/complete.png');
    }
  }
}
.qrInfo {
  max-width: 480px;
  margin: 0 auto 60px;
  padding: 30px;
  border-radius: 20px;
  border: 1px solid $color-lgrey2;
  p {
    font-size: 1.2em;
  }
}
.btns {
  display: flex;
  max-width: 480px;
  margin: 0 auto;
  .btn {
    flex: 1;
    padding-left: 0;
    padding-right: 0;
    border-radius: 8px;
    + .btn {
      margin-left: 15px;
    }
  }
}
.sendData {
  font-size: 1.2em;
}
</style>
